"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const luxon_1 = require("luxon");
const mui_1 = require("tss-react/mui");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const CalTxnsModal_1 = __importDefault(require("components/TransactionCalendar/MonthlyCalendar/CalTxnsModal"));
const Day_1 = __importDefault(require("../Day"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.daysGridStyles);
const DaysGrid = ({ daysTxsMap, curMonth, onTransactionClick }) => {
    const { classes } = useStyles();
    const isEntityShareEnableUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const todayDate = luxon_1.DateTime.local().toISODate();
    const navigate = (0, react_router_1.useNavigate)();
    const [showTxnModal, setShowTxnModal] = (0, react_1.useState)(null);
    const onTxnsModalOpen = (0, react_1.useCallback)((date) => setShowTxnModal(date), [setShowTxnModal]);
    const onTxnsModalClose = (0, react_1.useCallback)(() => setShowTxnModal(null), [setShowTxnModal]);
    const onGoToBills = (0, react_1.useCallback)((id) => navigate(`/bills-and-income?selectNode=${id}`, { replace: true }), [navigate]);
    const displayDaysTxsMap = (0, react_1.useMemo)(() => {
        if (!isEntityShareEnableUser || !daysTxsMap) {
            return daysTxsMap;
        }
        return daysTxsMap.map((txnList) => txnList.filter((txn) => { var _a; return !((_a = txn === null || txn === void 0 ? void 0 : txn.source) === null || _a === void 0 ? void 0 : _a.startsWith('SCHEDULED_TRANSACTION')); }));
    }, [daysTxsMap, isEntityShareEnableUser]);
    const renderedDays = (0, react_1.useMemo)(() => (displayDaysTxsMap && displayDaysTxsMap.map((txnList, date) => {
        const dateLux = luxon_1.DateTime.fromISO(date);
        const currentMonth = dateLux.month === curMonth.date.month;
        const currentDay = todayDate === date;
        const rowSize = displayDaysTxsMap.size / 7;
        return (<Day_1.default key={dateLux.toISODate()} day={dateLux.day} date={dateLux} currentMonth={currentMonth} currentDay={currentDay} txnList={txnList} onTxnsModalOpen={onTxnsModalOpen} rowSize={rowSize}/>);
    }).toList()), [displayDaysTxsMap, curMonth, todayDate, onTxnsModalOpen]);
    return (<div className={classes.days}>
      {displayDaysTxsMap && renderedDays}
      {showTxnModal && (<CalTxnsModal_1.default onClose={onTxnsModalClose} date={showTxnModal.toLocaleString(luxon_1.DateTime.DATE_HUGE)} txns={displayDaysTxsMap === null || displayDaysTxsMap === void 0 ? void 0 : displayDaysTxsMap.get(showTxnModal.toISODate())} onGoToRegister={onTransactionClick} onGoToBills={onGoToBills} useDashboardPrefFilter/>)}
    </div>);
};
DaysGrid.whyDidYouRender = true;
exports.default = (0, react_1.memo)(DaysGrid);
